import { useContext } from 'react';
import { NavLink } from '@/components/ui/link';
import { useDonorCopy } from './copy';
import { GivingContext } from './giving-context';
import { useSession } from './session';
export function DonorNavigation(): JSX.Element {
  const { t } = useDonorCopy();
  // The application recovery shell also renders outside GivingProvider.
  const giving = useContext(GivingContext);
  const session = useSession();
  const gifts = giving?.draft.items.length ?? 0;
  return (
    <nav className="giving-header-nav" aria-label={t.givingNavigation}>
      <NavLink to="/basket" aria-label={gifts ? `${t.basket} (${gifts})` : t.basket}>
        {t.basket}
        {gifts > 0 && (
          <span className="giving-header-nav__badge" aria-hidden="true">
            {gifts > 99 ? '99+' : gifts}
          </span>
        )}
      </NavLink>
      <NavLink to={session.profile ? '/account' : '/sign-in'}>
        {session.profile ? t.account : t.signIn}
      </NavLink>
    </nav>
  );
}
